import { useState } from "react";
import GameOver from "../../components/math-monster-battle/game_over";
import { getRandomQuestion } from "../../components/math-monster-battle/random_uestion";
import "../../assets/css/math-monster-battle.css";
import MathMonsterBattleMetas from "../../metas/math_monster_battle";

const TOTAL_ROUNDS = 5;
const MAX_LIVES = 3;

const MathMonsterBattle = () => {
  const [questionData, setQuestionData] = useState(getRandomQuestion());
  const [score, setScore] = useState(0);
  const [lives, setLives] = useState(MAX_LIVES);
  const [message, setMessage] = useState("");
  const [round, setRound] = useState(1);
  const [gameOver, setGameOver] = useState(false);

  const handleAnswer = (selected) => {
    const isCorrect = selected === questionData.answer;
    if (isCorrect) {
      setScore((prev) => prev + 1);
      setMessage("🎉 Correct!");
    } else {
      setLives((prev) => prev - 1);
      setMessage("❌ Oops! Try again.");
    }

    setTimeout(() => {
      if (lives <= 1 || round >= TOTAL_ROUNDS) {
        setGameOver(true);
      } else {
        setQuestionData(getRandomQuestion());
        setRound((prev) => prev + 1);
        setMessage("");
      }
    }, 1000);
  };

  const resetGame = () => {
    setScore(0);
    setLives(MAX_LIVES);
    setRound(1);
    setMessage("");
    setGameOver(false);
    setQuestionData(getRandomQuestion());
  };

  return (
    <>
      <MathMonsterBattleMetas />
      <div className="breadcrumbs" data-aos="fade-in">
        <div className="container">
          <h2>Math Monster Battle</h2>
          <p>
            Defeat the monster by solving math problems. Select the correct
            answer to earn points and survive the rounds!
          </p>
        </div>
      </div>

      {gameOver ? (
        <GameOver score={score} onReset={resetGame} />
      ) : (
        <div className="game-container">
          <div className="game-card">
            <h2 className="game-title">👾 Math Monster Battle</h2>
            <p className="game-round">
              Round {round}/{TOTAL_ROUNDS}
            </p>

            <div className="question">{questionData.question}</div>

            <div className="options-grid">
              {questionData.options.map((opt, idx) => (
                <button
                  key={idx}
                  className="option-button"
                  onClick={() => handleAnswer(opt)}
                >
                  {opt}
                </button>
              ))}
            </div>

            {message && <p className="status">{message}</p>}

            <div className="stats">
              <p>❤️ Lives: {lives}</p>
              <p>⭐ Score: {score}</p>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default MathMonsterBattle;
